"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTimeTrackLogsValue = exports.isFullTimeTrackingValue = exports.isPreviewTimeTrackingValue = void 0;
const dates_1 = require("./dates");
const custom_types_1 = require("./custom-types");
const number_1 = require("./number");
const objects_1 = require("./objects");
const typing_1 = require("./typing");
const primitives_1 = require("./primitives");
const date_range_1 = require("../../utils/date-range");
const arrays_1 = require("./arrays");
const isPreviewTimeTrackingValue = (fieldValue) => {
    if (!(0, objects_1.isObjectLikeValue)(fieldValue))
        return false;
    return ("total_duration" in fieldValue &&
        (0, number_1.isNullableNumberValue)(fieldValue.total_duration) &&
        !("time_track_logs" in fieldValue));
};
exports.isPreviewTimeTrackingValue = isPreviewTimeTrackingValue;
const isFullTimeTrackingValue = (fieldValue) => {
    return (0, objects_1.isValidObjectValue)(fieldValue, {
        active: (0, typing_1.Optional)(primitives_1.isBooleanValue),
        total_duration: number_1.isNullableNumberValue,
        time_track_logs: exports.isTimeTrackLogsValue,
    });
};
exports.isFullTimeTrackingValue = isFullTimeTrackingValue;
/**
 * Checks if the provided value is an array of time track logs
 * @param fieldValue
 */
const isTimeTrackLogsValue = (fieldValue) => {
    return (0, arrays_1.isArrayOfValidObjectsValue)(fieldValue, {
        date_time: dates_1.isDateAsStringValue,
        user_id: custom_types_1.isIDValue,
        duration: (0, typing_1.Optional)(primitives_1.isNumberValue),
        note: (0, typing_1.Optional)(primitives_1.isStringValue),
        id: custom_types_1.isIDValue,
        time_range: (0, typing_1.Optional)((0, typing_1.Union)(primitives_1.isNullValue, date_range_1.isDateRangeValue)),
        timer_start: (0, typing_1.Optional)((0, typing_1.Union)(primitives_1.isNullValue, dates_1.isDateAsStringValue)),
    });
};
exports.isTimeTrackLogsValue = isTimeTrackLogsValue;
